module.exports = __webpack_public_path__ + "img/04.fdd18cdb.png";